
import { Link } from 'react-router-dom';

export default function ArticleHero() {
  return (
    <>
      <section className="relative pt-24 pb-20 bg-gradient-to-br from-gray-900 via-gray-800 to-teal-900">
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="relative max-w-4xl mx-auto px-6 pt-16 text-center">
          <div className="flex items-center justify-center gap-4 mb-6">
            <span className="bg-teal-500/20 text-teal-300 text-xs font-semibold px-4 py-1.5 rounded-full">
              Tax Preparation
            </span>
            <span className="text-gray-400 text-sm">February 3, 2025</span>
            <span className="text-gray-400 text-sm">14 min read</span>
          </div>
          <h1 className="text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight">
            How to Compare Tax Preparation Services in El Paso TX: The Complete Guide for Business Owners
          </h1>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto leading-relaxed">
            Not all tax preparers are created equal. Learn exactly what to look for, what questions to ask, and how to find the right tax preparation service for your El Paso business.
          </p>
        </div>
      </section>

      <nav className="max-w-4xl mx-auto px-6 py-4 text-sm">
        <ol className="flex items-center gap-2 text-gray-500">
          <li><Link to="/" className="hover:text-teal-600 transition-colors cursor-pointer">Home</Link></li>
          <li><i className="ri-arrow-right-s-line"></i></li>
          <li><Link to="/blog" className="hover:text-teal-600 transition-colors cursor-pointer">Blog</Link></li>
          <li><i className="ri-arrow-right-s-line"></i></li>
          <li className="text-gray-900 font-medium">Compare Tax Preparation Services</li>
        </ol>
      </nav>

      <div className="max-w-5xl mx-auto px-6 mb-12">
        <div className="w-full h-96 rounded-2xl overflow-hidden shadow-xl">
          <img
            src="https://public.readdy.ai/ai/img_res/1f6f3f0027a92f7c00256042cb8f12f4.jpg"
            alt="how-to-compare-tax-preparation-services-el-paso-tx"
            title="How to Compare Tax Preparation Services in El Paso TX"
            className="w-full h-full object-cover object-top"
          />
        </div>
      </div>
    </>
  );
}
